import { LuIcon } from "@overmap-ai/blocks"
import type { IdentifierModel, IdentifierValueModel, UUID } from "@overmap-ai/common"
import type { ColumnDef } from "@tanstack/react-table"

import { modelIconMapping } from "../../../mappings/icons"
import { ColumnSortButton, ColumnSortIcon } from "../components"
import { EmptyColumnCellFallback } from "../components/EmptyColumnCellFallback"

export const getColumnDefOfIdentifier = <TIdentifier extends UUID<IdentifierModel>, TData>(
	identifier: TIdentifier,
	getIdentifierValue: (identifier: TIdentifier) => (data: TData) => IdentifierValueModel["value"] | undefined,
): ColumnDef<TData> => {
	return {
		id: identifier.uuid,
		accessorFn: getIdentifierValue(identifier),
		sortUndefined: "last",
		meta: {
			plainHeader: identifier.name,
		},
		header({ column }) {
			return (
				<ColumnSortButton column={column} variant="ghost" size="sm" accentColor="base">
					<LuIcon icon={modelIconMapping.identifier} />
					{identifier.name}
					<ColumnSortIcon sortDirection={column.getIsSorted()} />
				</ColumnSortButton>
			)
		},
		cell: ({ getValue }) => {
			const value = getValue<IdentifierValueModel["value"] | undefined>()
			if (value === undefined) return <EmptyColumnCellFallback />
			return value
		},
	}
}
export const getColumnDefsOfIdentifiers = <TIdentifier extends UUID<IdentifierModel>, TData>(
	identifiers: TIdentifier[],
	getIdentifierValue: (identifier: TIdentifier) => (data: TData) => IdentifierValueModel["value"] | undefined,
): ColumnDef<TData>[] => {
	return identifiers.map((identifier) => {
		return getColumnDefOfIdentifier(identifier, getIdentifierValue)
	})
}
